import { render, staticRenderFns } from "./TargetGroups.vue?vue&type=template&id=da513da8&scoped=true&"
import script from "./TargetGroups.vue?vue&type=script&lang=js&"
export * from "./TargetGroups.vue?vue&type=script&lang=js&"
import style0 from "./TargetGroups.vue?vue&type=style&index=0&id=da513da8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da513da8",
  null
  
)

export default component.exports